import { z } from 'zod'
import { tabeoErrorMap } from '../utils/zod-validation'

z.setErrorMap(tabeoErrorMap)

export default z
